import {Injectable} from '@angular/core'

@Injectable()
export class Window {
  public get instance() {
    return window
  }

  getInstance() {
    return window
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/window.ts